export const GET_DEALS_LISTING = "GET_DEALS_LISTING";
export const GET_DEALS_DETAIL = "GET_DEALS_DETAIL";
export const GET_DEALS_FORM_DATA = "GET_DEALS_FORM_DATA";
export const GET_ESTIMATE_FORM_DATA = "GET_ESTIMATE_FORM_DATA";
export const GET_PROPOSAL_BY_ID = "GET_PROPOSAL_BY_ID";
export const GET_PROPOSAL_DETAIL_BY_ID = "GET_PROPOSAL_DETAIL_BY_ID";
export const GET_PROPOSAL_BUILDER = "GET_PROPOSAL_BUILDER";
export const GET_PROPOSAL_BUILDER_DATA = "GET_PROPOSAL_BUILDER_DATA";
export const GET_PROPOSAL_LISTING_DATA = "GET_PROPOSAL_LISTING_DATA";
export const SEND_TO_PRODUCTION_FORM_DATA = "SEND_TO_PRODUCTION_FORM_DATA";
export const GET_CURRENT_PROPOSAL_BY_ID = "GET_CURRENT_PROPOSAL_BY_ID";
export const GET_CURRENT_PROPOSAL_DETAIL_BY_ID =
  "GET_CURRENT_PROPOSAL_DETAIL_BY_ID";
